import React, { useState } from 'react';
import axios from 'axios';
import API_URL from '../config';

const CustomerSupport = () => {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneCc, setPhoneCc] = useState('+91');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    if (!fullName || !email || !description) {
      setError('Please fill full name, email, and description.');
      return;
    }
    setLoading(true);
    try {
      const payload = {
        full_name: fullName,
        email,
        phone_cc: phoneCc || '',
        phone_number: phoneNumber || '',
        description,
      };
      const url = `${API_URL}/api/support-request/`;
      await axios.post(url, payload);
      setMessage('Support request submitted. We will respond shortly.');
      setFullName('');
      setEmail('');
      setPhoneCc('+91');
      setPhoneNumber('');
      setDescription('');
    } catch (err) {
      const detail = err?.response?.data?.detail || 'Submission failed. Please try again.';
      setError(typeof detail === 'string' ? detail : 'Submission failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4 overflow-x-hidden">
      <div className="card w-full max-w-xl p-6">
        <h1 className="section-title mb-4 text-2xl">Customer Support</h1>
        <p className="text-secondary-text mb-6">Tell us about the problem you faced. We’ll get back soon.</p>

        {message && (
          <div className="alert-success mb-4">{message}</div>
        )}
        {error && (
          <div className="alert-error mb-4">{error}</div>
        )}

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-sm text-secondary-text mb-1">Full name</label>
            <input
              type="text"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              className="w-full input-field px-3 py-2"
              placeholder="Your full name"
              required
            />
          </div>
          <div>
            <label className="block text-sm text-secondary-text mb-1">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full input-field px-3 py-2"
              placeholder="you@example.com"
              required
            />
          </div>
          <div className="grid grid-cols-3 gap-3">
            <div>
              <label className="block text-sm text-secondary-text mb-1">Country code</label>
              <input
                type="text"
                value={phoneCc}
                onChange={(e) => setPhoneCc(e.target.value)}
                className="w-full input-field px-3 py-2"
                placeholder="+91"
              />
            </div>
            <div className="col-span-2">
              <label className="block text-sm text-secondary-text mb-1">Phone number</label>
              <input
                type="tel"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                className="w-full input-field px-3 py-2"
                placeholder="9876543210"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm text-secondary-text mb-1">Describe your problem</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full input-field px-3 py-2 min-h-[120px]"
              placeholder="What happened?"
              required
            />
          </div>

          <div className="flex justify-end">
            <button
              type="submit"
              className="primary-btn px-4 py-2"
              disabled={loading}
            >
              {loading ? 'Sending…' : 'Send request'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CustomerSupport;
